import { useCallback, useState } from 'react';

import { useToast } from '@kanda-libs/ks-design-library';
import { actions } from '@kanda-libs/ks-frontend-services';

import { useAppDispatch } from 'components/shared/App';

import useApiError from './useApiError';

export interface SendConsentCommsHook {
  isSubmitting: boolean;
  sendConsentComms: (id: string) => void;
}

export default function useSendConsentComms(): SendConsentCommsHook {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const dispatch = useAppDispatch();
  const { showSuccess, showError } = useToast();
  const handleApiError = useApiError();

  const sendConsentComms = useCallback(
    (id: string) => {
      setIsSubmitting(true);
      dispatch(
        actions.migrateCredit({
          params: { id },
          onError: (error) => {
            setIsSubmitting(false);
            handleApiError(error || 'Error sending consent comms');
          },
          onSuccess: () => {
            setIsSubmitting(false);
            showSuccess('Consent comms sent successfully');
          },
        }),
      );
    },
    [handleApiError],
  );

  return {
    isSubmitting,
    sendConsentComms,
  };
}
